import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ns-dashboard-api.kabilah.com';

// roles: array of 'admin' | 'teacher' | 'student', omit for all
export function fetchAccounts(roles) {
  const params = roles && roles.length > 0 ? { roles: roles.join(',') } : {};
  return axios.get(`${BACKEND_URL}/api/accounts`, { params });
}

export function fetchTeachers() {
  return axios.get(`${BACKEND_URL}/api/teachers`);
}

// No password — the backend generates one and emails it directly to the
// new teacher.
export function createTeacher(firstName, lastName, email) {
  return axios.post(`${BACKEND_URL}/api/teachers`, { firstName, lastName, email });
}

export function deleteTeacher(id) {
  return axios.delete(`${BACKEND_URL}/api/teachers/${id}`);
}

// No password — students authenticate via Firebase only, not this dashboard.
export function createStudent(name, email) {
  return axios.post(`${BACKEND_URL}/api/students`, { name, email });
}

// Full, irreversible delete: removes the student's Firebase/app account, all
// session history and graded indicator results, class enrollments, and their
// roster row — not just an account unlink. requestedByEmail is sent so the
// backend can reject the request server-side if the caller is a teacher
// (there's no session/auth token to check against otherwise).
export function deleteStudent(id, requestedByEmail) {
  return axios.delete(`${BACKEND_URL}/api/students/${id}`, { params: { requestedBy: requestedByEmail } });
}

export function fetchAdmins() {
  return axios.get(`${BACKEND_URL}/api/admins`);
}

// No password — the backend generates one and emails it directly to the
// new admin.
export function createAdmin(firstName, lastName, email) {
  return axios.post(`${BACKEND_URL}/api/admins`, { firstName, lastName, email });
}

export function deleteAdmin(id) {
  return axios.delete(`${BACKEND_URL}/api/admins/${id}`);
}

// Self-service profile updates for the currently logged-in user, identified
// by email since the app has no session/id to key off of client-side.
export function updateProfile(email, { firstName, lastName }) {
  return axios.put(`${BACKEND_URL}/api/profile`, { email, firstName, lastName });
}

export function updateProfilePassword(email, currentPassword, newPassword) {
  return axios.put(`${BACKEND_URL}/api/profile/password`, { email, currentPassword, newPassword });
}
